export const RECEIVE_USER_BALANCE_DATA = 'RECEIVE_USER_BALANCE_DATA';
export const DEDUCT_USER_BALANCE_AMOUNT = 'DEDUCT_USER_BALANCE_AMOUNT';
export const UPDATE_USER_BALANCE_TO_AMOUNT = 'UPDATE_USER_BALANCE_TO_AMOUNT';
